import React from "react";
import { FormControl, InputLabel, Select, OutlinedInput, MenuItem, TextField, Button } from '@mui/material'
import withModal from '../../Modal';
import MemberAgeGroups from '../../../models/MemberAgeGroups';
import MemberGroupTypes from '../../../models/MemberGroupTypes';
//import EventOptionAvailabilityTypes from '../../../models/EventOptionAvailabilityTypes';
//import EventOptions from '../../../models/EventOptions';
import EventAdditonalPriceTypes from '../../../models/EventAdditionalPriceType';

const OptionsModal = (props: any) => {

    let ageGroups: JSX.Element[] = (props.ageGroups as MemberAgeGroups[]).map(x => {
        return <MenuItem key={x.id} value={x.id}>{x.groupName} {x.groupAgeFrom} - {x.groupAgeTo}</MenuItem>
    })

    let groupTypes: JSX.Element[] = (props.groupTypes as MemberGroupTypes[]).map(x => {
        return <MenuItem key={x.id} value={x.id}>{x.groupName}</MenuItem>
    })

    let eventAdditionalPriceTypes: JSX.Element[] = (props.eventAdditionalPriceTypes as EventAdditonalPriceTypes[]).map(x => {
        return <MenuItem key={x.id} value={x.id}>{x.priceTypeDescription}</MenuItem>
    })

    let memberGroupTypeValue
    if(props.method === 'Submit') {
        if(typeof props.newObject.newMemberGroupTypeIds !== 'undefined')
            memberGroupTypeValue = props.newObject.newMemberGroupTypeIds
        else
            memberGroupTypeValue = []
    } else {
        if(typeof props.newObject.memberGroupTypeId !== 'undefined')
            memberGroupTypeValue = props.newObject.memberGroupTypeId
        else
            memberGroupTypeValue = ''
    }

    let memberAgeGroupValue
    if(props.method === 'Submit') {
        if(typeof props.newObject.newMemberAgeGroupIds !== 'undefined')
            memberAgeGroupValue = props.newObject.newMemberAgeGroupIds
        else
            memberAgeGroupValue = []
    } else {
        if(typeof props.newObject.memberAgeGroupId !== 'undefined')
            memberAgeGroupValue = props.newObject.memberAgeGroupId
        else
            memberAgeGroupValue = ''
    }

    return (
        <div className='modal' style={{ display: 'block', zIndex: 1200, position: 'fixed', top: '20%' }} role='dialog'>
            <div className='modal-dialog'>
                <div className='modal-content'>
                    <div className='modal-body'>
                        <div className='row'>
                            <div className='col-xs-6 col-sm-6 col-md-6 co-lg-6'>
                                <FormControl variant="outlined" fullWidth className='mt-2'>
                                    <InputLabel htmlFor="outlined-aktiv">
                                        Option *
                                    </InputLabel>
                                    <Select
                                        input={
                                            <OutlinedInput id='outlined-aktiv' fullWidth />
                                        }
                                        name='eventAdditionalPriceTypeId'
                                        error={!props.validRequiredFields.eventAdditionalPriceTypeId}
                                        value={typeof props.newObject.eventAdditionalPriceTypeId !== 'undefined' ? props.newObject.eventAdditionalPriceTypeId : ''}
                                        onChange={(e:any) => props.change(e)}
                                        fullWidth
                                    >
                                        <MenuItem value="">
                                            <em></em>
                                        </MenuItem>
                                        {eventAdditionalPriceTypes}
                                    </Select>
                                </FormControl>
                                <TextField
                                    label='Beschreibung:'
                                    name='description'
                                    value={typeof props.newObject.description !== 'undefined' ? props.newObject.description : ''}
                                    onChange={(e:any) => props.change(e)}
                                    className='mt-2' />
                                <TextField
                                    label='Kontingente: '
                                    name='limitCount'
                                    value={typeof props.newObject.limitCount !== 'undefined' ? props.newObject.limitCount : ''}
                                    onChange={(e:any) => props.change(e)}
                                    className='mt-2' />
                            </div>
                            <div className='col-xs-6 col-sm-6 col-md-6 co-lg-6'>
                                <FormControl variant="outlined" fullWidth className='mt-2'>
                                    <InputLabel htmlFor="outlined-aktiv">
                                        Teilnehmergruppe: *
                                    </InputLabel>
                                    <Select
                                        multiple={props.method === 'Submit'}
                                        input={
                                            <OutlinedInput id='outlined-aktiv' fullWidth />
                                        }
                                        name={props.method === 'Submit' ? 'newMemberGroupTypeIds' : 'memberGroupTypeId'}
                                        value={memberGroupTypeValue}
                                        onChange={(e:any) => props.change(e)}
                                        fullWidth
                                    >
                                        <MenuItem value="">
                                            <em></em>
                                        </MenuItem>
                                        {groupTypes}
                                    </Select>
                                </FormControl>
                                <FormControl variant="outlined" fullWidth className='mt-2'>
                                    <InputLabel htmlFor="outlined-aktiv">
                                        Altersklasse: *
                                    </InputLabel>
                                    <Select
                                        multiple={props.method === 'Submit'}
                                        input={
                                            <OutlinedInput id='outlined-aktiv' fullWidth />
                                        }
                                        name={props.method === 'Submit' ? 'newMemberAgeGroupIds' : 'memberAgeGroupId'}
                                        value={memberAgeGroupValue}
                                        onChange={(e:any) => props.change(e)}
                                        fullWidth
                                    >
                                        <MenuItem value="">
                                            <em></em>
                                        </MenuItem>
                                        {ageGroups}
                                    </Select>
                                </FormControl>
                                <TextField
                                    label='Preis: *'
                                    name='priceValue'
                                    error={!props.validRequiredFields.priceValue}
                                    value={typeof props.newObject.priceValue !== 'undefined' ? props.newObject.priceValue.toString().replace('.',',') : ''}
                                    onChange={(e:any) => { 
                                        e.target.value = e.target.value.replace(',','.')
                                        props.change(e)
                                    }}
                                    />
                            </div>
                        </div>
                    </div>
                    <div className='modal-footer'>
                        <Button
                            className='btn'
                            color='secondary'
                            variant='contained'
                            onClick={() => props.hide()}>
                            Abbrechen
                                </Button>
                        <Button
                            className='btn'
                            color='primary'
                            variant='contained'
                            onClick={() => props.submit()}>
                            Hinzufügen
                                </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withModal(OptionsModal)